import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { H, Flex, Text, DropdownOptions, TooltipPopup } from 'dash-ui';
import ResetPasswordForm from 'pages/Authentication/ResetPasswordPage/components/ResetPasswordForm/ResetPasswordForm';
import AuthenticationPageLayout from 'flow-components/AuthenticationPageLayout/AuthenticationPageLayout';

function ResetPasswordPage() {
  const { t } = useTranslation('pages', { keyPrefix: 'resetPasswordPage' });
  const theme = useTheme();
  return (
    <AuthenticationPageLayout>
      <DropdownOptions />
      <TooltipPopup />
      <Flex flexDirection="column" w={334}>
        <Flex flexDirection="column">
          <H bold sm as={4}>{t`welcomeHeader`}</H>
          <Text color={theme.colors.n70}>{t`welcomeSubHeader`}</Text>
        </Flex>
        <ResetPasswordForm />
      </Flex>
    </AuthenticationPageLayout>
  );
}

export default ResetPasswordPage;
